import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/exame-laboratorial`

    const headers = { responseType: "arraybuffer" }

    return {
       relatorioExameBloqueado(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-bloqueado?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPacienteAtendido(queryParms) {

            return repository.get(`${baseUrl}/relatorio-paciente-atendido?${urlUtil.serialize(queryParms)}`, headers)
        },
        agendamento(id) {

            return repository.get(`${baseUrl}/relatorio-agendamento/${id}`, headers)
        },
        etiqueta(id) {

            return repository.get(`${baseUrl}/relatorio-etiqueta/${id}`, headers)
        },
        etiquetaLancamento(id) {

            return repository.get(`${baseUrl}/relatorio-etiqueta-lancamento/${id}`, headers)
        },
        lancamentoColeta(queryParms) {

            return repository.get(`${baseUrl}/relatorio-lancamento-coleta?${urlUtil.serialize(queryParms)}`, headers)
        },
        mapaProducao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-mapa-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        exameResultado(id) {

            return repository.get(`${baseUrl}/exame-resultado/${id}`, headers)
        },
        exameResultadoAgrupado(id) {

            return repository.get(`${baseUrl}/exame-resultado-agrupado/${id}`, headers)
        },
        exame(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame?${urlUtil.serialize(queryParms)}`, headers)
        },
        exameList(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-list?${urlUtil.serialize(queryParms)}`, headers)
        },
        entregaExame(queryParms) {

            return repository.get(`${baseUrl}/relatorio-entrega-exame?${urlUtil.serialize(queryParms)}`, headers)
        },
        entregaExameList(queryParms) {

            return repository.get(`${baseUrl}/relatorio-entrega-exame-list?${urlUtil.serialize(queryParms)}`, headers)
        },
        entregaExameSelecionado(queryParms) {

            return repository.get(`${baseUrl}/relatorio-entrega-exame-selecionado?${urlUtil.serialize(queryParms)}`, headers)
        },
        exameAgendadoRealizado(id)  {

            return repository.get(`${baseUrl}/relatorio-exame-agendado-realizado/${id}`, headers)
        },
        coletaAgendada(params) {

            return repository.post(`${baseUrl}/relatorio-coleta-agendada`, params, headers)
        },
        mapaDia(queryParms) {

            return repository.get(`${baseUrl}/relatorio-mapa-dia?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioCotaConsumo(queryParms){
            return repository.get(`${baseUrl}/relatorio-cota-consumo?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioExameSolicitadoStatus(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-solicitado-status?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioExameProducao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioFinanceiroPaciente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-financeiro-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioColetaRealizada(queryParms) {
            return repository.get(`${baseUrl}/relatorio-coleta-realizada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioFinanceiroExame(queryParms) {

            return repository.get(`${baseUrl}/relatorio-financeiro-exame?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoProducao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-quantitativo-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoExameSolicitado(queryParms) {

            return repository.get(`${baseUrl}/relatorio-quantitativo-exame-solicitado?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioHistoricoPaciente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-historico-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioExameLaboratorioApoio(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-laboratorio-apoio?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}